import { Download } from "@mui/icons-material"
import { Button } from "@mui/material"

export default function Invoice({indent}){

    return indent?.paid && 
        <Button
            variant='outlined'
            href={indent?.invoiceUrl}
            target='_blank'
            rel='noopener noreferrer'
            download
            startIcon={<Download/>}
        >
            Télécharger la facture
        </Button>
}